import { SEOHead } from '@/components/seo';
import { PAGE_SEO } from '@/lib/seo-config';

export default function Terms() {
  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <SEOHead
        title={PAGE_SEO.terms.title}
        description={PAGE_SEO.terms.description}
        keywords={PAGE_SEO.terms.keywords}
        url="/legal/terms"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Terms of Service', url: '/legal/terms' },
        ]}
      />
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 data-testid="terms-title" className="text-4xl font-bold text-white mb-4 section-marker font-mono">Terms of Service</h1>
          <p className="text-xs font-mono text-zinc-500 mb-12">Last updated: February 1, 2026</p>
          <div className="prose prose-invert prose-sm max-w-none space-y-8">
            {[
              { title: '1. Acceptance of Terms', body: 'By accessing and using ClawStinger ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.' },
              { title: '2. Description of Service', body: 'ClawStinger provides managed hosting for OpenClaw AI agents, including VPS provisioning, configuration, and management tools. The Service is provided on a subscription or credit-based basis.' },
              { title: '3. User Accounts', body: 'You must provide accurate and complete registration information. You are responsible for maintaining the security of your account and all activities under your account. You must notify us immediately of any unauthorized use.' },
              { title: '4. Acceptable Use', body: 'You agree not to use the Service for any illegal purposes, to violate any laws, to infringe on intellectual property rights, to send spam or malicious content, or to attempt to gain unauthorized access to other systems.' },
              { title: '5. Payment Terms', body: 'Subscription fees are billed in advance on a monthly or annual basis. Credits are non-refundable. We reserve the right to change pricing with 30 days notice.' },
              { title: '6. Service Level Agreement', body: 'We guarantee 99.9% uptime for all paid plans. Downtime excludes scheduled maintenance windows. Credits may be issued for extended outages.' },
              { title: '7. Data & Privacy', body: 'We take data privacy seriously. Your instance data is encrypted at rest and in transit. We do not access your instance data unless required for support at your request. See our Privacy Policy for details.' },
              { title: '8. Limitation of Liability', body: 'The Service is provided "as is" without warranties of any kind. Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim.' },
              { title: '9. Termination', body: 'Either party may terminate at any time. Upon termination, your instances will be stopped and data retained for 30 days before deletion. You may export your data before termination.' },
            ].map((s, i) => (
              <div key={i}>
                <h2 className="text-lg font-mono text-white font-bold mb-2">{s.title}</h2>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
